import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
  MinistryAppointmentClient,
  MinistryAppointmentDto,
  CreateMinistryAppointmentDto,
  UpdateMinistryAppointmentDto,
  UpdateMinistryAppointmentSortOrderDto,
} from '../generated/api-client';

@Injectable({ providedIn: 'root' })
export class MinistryAppointmentApiService {
  constructor(private readonly client: MinistryAppointmentClient) {}

  getAll(): Observable<MinistryAppointmentDto[]> {
    return this.client.getAll();
  }

  getById(id: number): Observable<MinistryAppointmentDto> {
    return this.client.getById(id);
  }

  create(dto: CreateMinistryAppointmentDto): Observable<MinistryAppointmentDto> {
    return this.client.create(dto);
  }

  update(id: number, dto: UpdateMinistryAppointmentDto): Observable<void> {
    return this.client.update(id, dto);
  }

  delete(id: number): Observable<void> {
    return this.client.delete(id);
  }

  updateSortOrder(id: number, dto: UpdateMinistryAppointmentSortOrderDto): Observable<void> {
    return this.client.updateSortOrder(id, dto);
  }
}
